import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, mergeMap, delay, tap, switchMap } from "rxjs/operators";
import { of } from "rxjs";
import { CptsActions } from "./cpt.actions";
import { AdministrationService } from "../../service/administration.service";
import { MessageService } from 'primeng/api';
import { CptCatalogueNode, DownloadCptCatalogueQueryResponse, GetCptTreeQuery } from "../../../../graphql/generated";
import { CptService } from "../../service/cpt.service";
import { Cpts } from "../../shared/models/cpt.model";
import { GraphQLResponse } from "../../shared/models/grapql.models";
@Injectable()
export class CptEffects {
  startTime = 0;

  loadCpt$ = createEffect(
    (as: CptService = inject(CptService)) => {
      return this.actions$.pipe(
        tap(() => this.startTime = Date.now()),
        ofType(CptsActions.loadCpts),
        switchMap(({ parameters, filtering, fields }) =>
          /** An EMPTY observable only emits completion. Replace with your own observable API request */
          as.getCpts(parameters).pipe(
            map((cpts) => {
              return CptsActions.loadCptsSuccess({
                cpts: cpts as GraphQLResponse<Cpts>,
                filtering: filtering,
                fields
              });
            }),
            catchError((error) => of(CptsActions.loadCptsFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  loadCptsTree$ = createEffect(
    (as: CptService = inject(CptService)) => {
      return this.actions$.pipe(
        ofType(CptsActions.loadCptsTree),
        switchMap(({ parameters, filtering, fields }) =>
          as.getCptsTree(parameters).pipe(
            map((cpts) => {
              return CptsActions.loadCptsTreeSuccess({
                cpts: cpts as GetCptTreeQuery['commonProcessTree'],
                filtering: filtering,
                fields
              });
            }),
            catchError((error) => of(CptsActions.loadCptsTreeFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  loadCptsActive$ = createEffect(
    (as: AdministrationService = inject(AdministrationService)) => {
      return this.actions$.pipe(

        ofType(CptsActions.loadCptsActive),
        mergeMap(() =>
          /** An EMPTY observable only emits completion. Replace with your own observable API request */
          as.getActiveCpts().pipe(
            map((cpts) => {
              // // //console.log"Users response:", users);
              return CptsActions.loadCptsActiveSuccess({
                cpts: (cpts?.data ?? []) as CptCatalogueNode[]
              });
            }),
            catchError((error) => of(CptsActions.loadCptsActiveFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  exportCpts$ = createEffect(
    (as: CptService = inject(CptService), ad: AdministrationService = inject(AdministrationService)) => {
      return this.actions$.pipe(
        ofType(CptsActions.exportCpts),
        mergeMap(({ parameters, timeZone }) =>
          as.exportCpts(parameters, timeZone).pipe(
            map((cpts) => {
              ad.downloadFile(
                cpts!.data![0]!.content,
                cpts!.data![0]!.filename
              );
              return CptsActions.exportCptsSuccess({
                cpts: cpts!.data as DownloadCptCatalogueQueryResponse
              });
            }),
            catchError((error) => of(CptsActions.exportCptsFailure({ error })))
          )
        )
      )
    }
  )

  syncronize$ = createEffect(
    (leService: CptService = inject(CptService), messageService: MessageService = inject(MessageService)) => {
      return this.actions$.pipe(
        ofType(CptsActions.syncronizeCpts),
        tap(() => {
          messageService.add({ summary: 'Synchronization in progress', detail: '...', severity: 'info', life: 1500 })
        }),
        mergeMap(() =>
          leService.syncronizeCpt().pipe(
            delay(3000),
            map(() => {
              messageService.add({ summary: 'Synchronization completed', detail: 'the data is up to date.', severity: 'success' })
              //lancio mS per lanciare il toast
              return CptsActions.loadCptsTree(
                {
                  parameters: {
                    page: 0,
                    order: {
                      sortField: "orderId",
                      sortDirection: "ASC"
                    },
                    search: null,
                    filters: {},
                    rows: 10000
                  }
                }
              );
            }),
            catchError(() => {
              return of(CptsActions.loadCptsTree(
                {
                  parameters: {
                    page: 0,
                    order: {
                      sortField: "orderId",
                      sortDirection: "ASC"
                    },
                    search: null,
                    filters: {},
                    rows: 10000
                  }
                }
              )
              )
            }
            )
          )
        )
      );
    },
    { functional: true }
  );

  constructor(private actions$: Actions) { }
}
